import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const LOGO_LABEL_STYLE = {
    width: '355px',
    height: '104px',
    border: '2px dashed #C7C7C7',
    borderRadius: '8px',
    cursor: 'pointer',
};

/**
 * ช่องอัปโหลดโลโก้ในหน้าตั้งค่าธีม เดิม JSX นี้ซ้ำกันเป๊ะทั้งใน CreatePortal.jsx
 * (state เป็น File object ใช้ URL.createObjectURL) และ EditPortal.jsx (state เป็น
 * base64 string) — เพื่อไม่ต้องเปลี่ยนวิธีเก็บ state ของแต่ละไฟล์ ให้ผู้เรียกคำนวณ
 * `logoSrc` (string สำหรับ <img src>) และ `hasLogo` (boolean) เองแล้วส่งเข้ามา
 */
const LogoUploadField = ({ hasLogo, logoSrc, onChange, onClear, accept }) => (
    <div style={{ marginBottom: '10px', display: 'flex' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {hasLogo ? (
                <>
                    <label htmlFor="file-input" style={LOGO_LABEL_STYLE}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img
                                src={logoSrc}
                                alt="img"
                                style={{ maxHeight: '80px', maxWidth: '140px', marginTop: '10px', position: 'absolute' }}
                            />
                        </div>
                    </label>
                    <DeleteOutlineIcon style={{ cursor: 'pointer', color: 'red' }} onClick={onClear} />
                </>
            ) : (
                <label htmlFor="file-input" style={LOGO_LABEL_STYLE}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <InsertPhotoIcon style={{ color: '#C7C7C7', marginTop: '20px', width: '35px', height: '35px' }} />
                        <div style={{ color: '#C7C7C7' }}>อัปโหลดไฟล์ PNG, JPG ขนาดXXX</div>
                    </div>
                </label>
            )}
            <input type="file" id="file-input" onChange={onChange} accept={accept} style={{ display: 'none' }} />
        </div>
    </div>
);

export default LogoUploadField;